import styled, { css } from 'styled-components';

import { Flex } from '@/components/Flex';

export const AlertMessage = styled(Flex)<{ type: 'warning' | 'info' }>`
  ${({ theme, type }) => css`
    background: #fff8e0;
    padding: ${theme.spacing(2)};

    svg {
      margin-right: ${theme.spacing(2)};
      path {
        ${type === 'warning'
          ? css`
              fill: ${theme.colors.accent};
            `
          : css`
              fill: ${theme.colors.secondaryGrey};
            `}
      }
    }
  `}
`;
